import { createSlice } from '@reduxjs/toolkit';

const initialFilterState = {
  genericSearch: '',
  hierarchy: [],
  contactName: '',
  childId: '',
  contactEmail: '',
  accountPhone: '',
  dbaName: '',
  transactionRef: '',
  transactionAmt: '',
  transactionStart: null,
  transactionEnd: null,
  transactionMethod: '',
  transactionCard: '',
  transactionType: '',
  transactionStatus: '',
};

const filterSlice = createSlice({
  name: 'filter',
  initialState: initialFilterState,
  reducers: {
    clearFilter: () => initialFilterState,
    updateGenericSearchFilter: (state, { payload }) => {
      state.genericSearch = payload;
    },
    updateAccountTypeFilter: (state, { payload }) => {
      state.hierarchy = payload;
    },
    updateContactNameFilter: (state, { payload }) => {
      state.contactName = payload;
    },
    updateAccountIdFilter: (state, { payload }) => {
      state.childId = payload;
    },
    updateAccountEmailFilter: (state, { payload }) => {
      state.contactEmail = payload;
    },
    updateAccountPhoneFilter: (state, { payload }) => {
      state.accountPhone = payload;
    },
    updateTransactionRef: (state, { payload }) => {
      state.transactionRef = payload;
    },
    updateTransactionAmt: (state, { payload }) => {
      state.transactionAmt = payload;
    },
    updateTransactionStart: (state, { payload }) => {
      console.log(payload);
      state.transactionStart = payload;
    },
    updateTransactionEnd: (state, { payload }) => {
      state.transactionEnd = payload;
    },
    updateTransactionMethod: (state, { payload }) => {
      state.transactionMethod = payload;
    },
    updateTransactionCard: (state, { payload }) => {
      state.transactionCard = payload;
    },
    updateTransactionType: (state, { payload }) => {
      state.transactionType = payload;
    },
    updateTransactionStatus: (state, { payload }) => {
      state.transactionStatus = payload;
    },
    updateDbaNameFilter: (state, { payload }) => {
      state.dbaName = payload;
    },
    updateAllFilter: (state, { payload }) => {
      return payload;
    },
  },
});

export const {
  clearFilter,
  updateGenericSearchFilter,
  updateAccountTypeFilter,
  updateContactNameFilter,
  updateAccountIdFilter,
  updateAccountEmailFilter,
  updateAccountPhoneFilter,
  updateTransactionRef,
  updateTransactionAmt,
  updateTransactionStart,
  updateTransactionEnd,
  updateTransactionMethod,
  updateTransactionCard,
  updateTransactionType,
  updateTransactionStatus,
  updateDbaNameFilter,
  updateAllFilter,
} = filterSlice.actions;
export default filterSlice.reducer;
